(function () {
  'use strict';
  if (window.okrgInit) return; window.okrgInit = 1;
  var cfgEl = document.querySelector('[data-okrg-cfg]');
  if (!cfgEl) return;
  var C; try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var VID = Number(C.vid), UMBRAL = Number(C.umbral);
  if (!VID || !UMBRAL) return;
  var drawer = document.getElementById('CartDrawer');
  var CODIGOS = (C.codigos || []).filter(Boolean), DESDE = Number(C.desde) || 0;
  /* La versión del 28/09 por la mañana excluía a quien había visto el pop-up y lo guardaba aquí: se borra. */
  try { localStorage.removeItem('okp_regalo_excl'); } catch (e) {}

  /* ¿Lleva ya la promo de muestras (código PAMI / DAMELO o flujo PAMI)? Entonces el regalo son «6 más». */
  function conPami(cart) {
    var si = false;
    try { if (sessionStorage.getItem('pami_flow') === 'true') si = true; } catch (e) {}
    (cart.discount_codes || []).forEach(function (d) { if (CODIGOS.indexOf(String(d.code || '').toUpperCase()) > -1) si = true; });
    return si;
  }

  var busy = false, timer = null, lastAdd = 0;
  var fmt = function (c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; };

  /* /cart: la misma franja encima del pedido (copia de la del drawer). */
  function franjaPagina() {
    var form = document.getElementById('CartPageForm');
    if (!form || document.querySelector('.okrg-page')) return;
    var src = document.querySelector('#CartDrawer [data-okrg]');
    if (!src) return;
    var c = src.cloneNode(true); c.classList.add('okrg-page');
    form.parentNode.insertBefore(c, form);
  }

  function pintar(total, tiene, pami) {
    var fuera = !tiene && total < DESDE;
    if (drawer) drawer.classList.toggle('okrg-on', !fuera);
    if (fuera) { document.querySelectorAll('.okrg-page').forEach(function (el) { el.remove(); }); return; }
    franjaPagina();
    var falta = Math.max(0, UMBRAL - total), pct = Math.min(100, total / UMBRAL * 100);
    var html = tiene ? (pami ? C.ok_mas : C.ok) : (pami ? C.falta_mas : C.falta).replace('[[falta]]', fmt(falta));
    document.querySelectorAll('[data-okrg]').forEach(function (el) {
      el.classList.toggle('is-ok', !!tiene);
      var m = el.querySelector('[data-okrg-msg]'), f = el.querySelector('[data-okrg-fill]');
      /* Solo se escribe si cambia: evita el bucle observer → sync → escritura. */
      if (m && m.__h !== html) { m.__h = html; m.innerHTML = html; }
      if (f) f.style.width = (tiene ? 100 : pct) + '%';
    });
  }

  function post(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
  }
  function despues() {
    busy = false;
    if (document.getElementById('CartPageForm')) { setTimeout(function () { location.reload(); }, 100); return; }
    try { document.dispatchEvent(new CustomEvent('cart:build')); } catch (e) {}
    setTimeout(sync, 300);
  }

  function syncAhora() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
      var regalo = null, otros = 0;
      cart.items.forEach(function (i) { if (i.variant_id === VID) regalo = i; else otros += i.quantity; });
      var total = cart.total_price;
      pintar(total, !!regalo && otros > 0 && total >= UMBRAL, conPami(cart));
      /* Carritos que ya tenían el regalo con la marca antigua: se quita y el siguiente sync lo vuelve a añadir limpio. */
      if (regalo && regalo.properties && regalo.properties._okp_regalo) return post('/cart/change.js', { id: regalo.key, quantity: 0 }).then(despues);
      if (regalo && (otros === 0 || total < UMBRAL)) return post('/cart/change.js', { id: regalo.key, quantity: 0 }).then(despues);
      if (regalo && regalo.quantity > 1) return post('/cart/change.js', { id: regalo.key, quantity: 1 }).then(despues);
      if (!regalo && otros > 0 && total >= UMBRAL) {
        /* Un intento cada 1,5 s como mucho: si el add tarda en verse en /cart.js no se repite en bucle. */
        if (Date.now() - lastAdd < 1500) { busy = false; return; }
        lastAdd = Date.now();
        /* Sin propiedades de línea: el Flow de Shopify copia las propiedades de los packs de muestras a las
           notas del pedido, y «_okp_regalo: 50» acababa como «[MUESTRAS: 50]» (29/09). El regalo se reconoce
           por su variante, no hace falta marcarlo. */
        return post('/cart/add.js', { items: [{ id: VID, quantity: 1 }] })
          .then(function (r) { if (r.status === 422) { busy = false; return; } despues(); });
      }
      busy = false;
    }).catch(function () { busy = false; });
  }
  function sync() { clearTimeout(timer); timer = setTimeout(syncAhora, 80); }

  ['cart:open', 'cart:updated', 'cart:build', 'cart:refresh', 'ajaxProduct:added'].forEach(function (ev) { document.addEventListener(ev, sync); });
  if (drawer) {
    var items = drawer.querySelector('[data-products]');
    if (items) new MutationObserver(sync).observe(items, { childList: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncAhora); else syncAhora();
})();
